/**
 * This file is the entry point for the application.
 * It imports the CSS file and initializes the functions on DOMContentLoaded event.
 */
import '../css/app.css';

import theme from './theme';

document.addEventListener('DOMContentLoaded', function() {

	theme ();

});
